import React from 'react';
import PropTypes from 'prop-types';

import { CustomTooltip } from '../../Poppers';
import Icons, { IconSizes } from '../../Icons';
import { Themes } from '../../../style/theme-consts';

import * as S from './styled';

const TitleWithTooltip = ({ label, tooltip, required, titleIcon, isUpperCase, justifyContent }) => (
  <S.Label $isUpperCase={isUpperCase} $justifyContent={justifyContent}>
    {titleIcon}
    {label}
    {required && <S.Required>*</S.Required>}
    {!!tooltip && (
      <CustomTooltip title={tooltip} mode={Themes.LIGHT} placement="right">
        <div>
          <Icons.Info size={IconSizes.S} />
        </div>
      </CustomTooltip>
    )}
  </S.Label>
);

TitleWithTooltip.propTypes = {
  label: PropTypes.node,
  required: PropTypes.bool,
  tooltip: PropTypes.node,
  titleIcon: PropTypes.node,
  isUpperCase: PropTypes.bool,
  justifyContent: PropTypes.string
};

export default TitleWithTooltip;
